<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;专家详情
        </div>
        <div class="tankuangmain" ref="wrapper">
            <div class="tktop">
                <div class="tktopleft">
                    <div class="txout">
                        <img v-if="docinnerlist.ExpertHead" :src="docinnerlist.ExpertHead" alt=""
                            class="lefttouxiang" />
                        <img v-else src="../../assets/images/nonehead.png" alt="" class="lefttouxiang" />
                    </div>
                </div>
                <div class="tktopright">
                    <div class="tkname">{{ docinnerlist.ExpertName }}</div>
                    <div class="tkhos">{{ docinnerlist.ExpertHospital }}</div>
                </div>
            </div>
            <div class="tkinnerrow" v-for="(item, index) in docinnerlist.Schedule" :key="index"
                @click="gomeeting(item.ActivityScheduleId)">
                <div class="tkdayrow">
                    <span class="day"><img src="../../assets/images/tkday.png" class="tkimg" /><span>{{
                        item.DateStr
                            }}</span></span>
                </div>
                <div class="tkxueshurow" v-if="item.Mission">学术任务：{{ item.Mission }}</div>
                <div class="tkxueshurow" v-else>学术任务：暂无</div>
                <div class="tkkhrow">【{{ item.Theme }}】</div>
                <div class="tktitlerow">{{ item.Title }}</div>
                <div class="tktime"><img src="../../assets/images/cutime.png" class="tkimg" /><span>{{
                    item.StartTimeStr }} - {{ item.EndTimeStr }}</span></div>
                <div class="tkpos"><img src="../../assets/images/cutpos.png" class="tkimg" /><span>{{
                    item.Address
                        }}</span></div>
                <div style="text-align: right;">
                    <div class="tkopen">查看对应会场详情</div>
                </div>
            </div>
        </div>
        <div class="backbtn" @click="back()">
            <img src="../../assets/images/backicon.png" alt="">
        </div>
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from "mescroll.js/mescroll.vue";
export default {
    name: 'customzj',
    data() {
        return {
            imgurl: '',
            meetinginfo: [],
            Name: this.$route.query.Name,
            docinnerlist: [],
        }
    },
    mixins: [mixin],
    created() {
        this.openlist();
        // this.getmod();
        document.title = '专家详情';
    },
    mounted() {
        this.initDrag();
    },
    methods: {
        openlist() {
            let that = this;
            that.docinnerlist = [];
            // console.log(i)
            this.$axios.get('/api/api/web/activity/GetScheduleByExpert?expertId=' + this.$route.query.Id + '&ActivityId=' + this.$route.query.ActivityId).then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data.Url)
                    that.docinnerlist = res.Data;
                    console.log(that.docinnerlist)
                    // that.imgurl = res.Data.Url
                    // this.initBScroll()
                }
            });
        },
        gomeeting(id) {
            this.$router.push({
                path: 'custommeeting',
                query: {
                    Id: id,
                    ActivityId: this.$route.query.ActivityId
                }
            });
        },
        back() {
            this.$router.replace({
                path: "custom",
                query: {
                    Id: this.$route.query.ActivityId,
                },
            });
        },
        initDrag() {
            const btn = document.querySelector('.backbtn');
            if (!btn) return;

            // 触摸开始（移动端）
            btn.addEventListener('touchstart', (e) => {
                this.isDragging = true;
                // 获取初始触摸位置
                this.startX = e.touches[0].clientX;
                this.startY = e.touches[0].clientY;
                // 获取按钮当前位置
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                // 阻止默认行为
                // e.preventDefault();
            });

            // 触摸移动（移动端）
            btn.addEventListener('touchmove', (e) => {
                if (!this.isDragging) return;
                // 计算移动距离
                const moveX = e.touches[0].clientX - this.startX;
                const moveY = e.touches[0].clientY - this.startY;
                // 设置按钮新位置
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                // 清除原有right/transform
                btn.style.right = 'auto';
                btn.style.transform = 'none';
                e.preventDefault();
            });

            // 触摸结束（移动端）
            btn.addEventListener('touchend', () => {
                this.isDragging = false;
            });

            // 兼容PC端鼠标操作
            btn.addEventListener('mousedown', (e) => {
                this.isDragging = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                e.preventDefault();
            });

            document.addEventListener('mousemove', (e) => {
                if (!this.isDragging) return;
                const moveX = e.clientX - this.startX;
                const moveY = e.clientY - this.startY;
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                btn.style.right = 'auto';
                btn.style.transform = 'none';
            });

            document.addEventListener('mouseup', () => {
                this.isDragging = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset;
    background: rgb(228, 236, 255);
}

.container {
    min-height: 100%;
    width: 100%;
    background: rgb(228, 236, 255);
    position: relative;
}

.total {
    position: relative;
    height: 100%;
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background: #003583;
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.mainimg {
    width: 100%;
    position: relative;
    z-index: 100;
    margin-bottom: 1.8rem;
}

.tankuangmain {
    width: 100%;
    border-radius: 0.5rem;
    padding: 0 5%;
    box-sizing: border-box;
    padding-top: 0.4rem;
    background: rgb(228, 236, 255);
}

.tktop {
    display: flex;
    flex-direction: row;
    width: 100%;
    color: #0039A9;
    padding: 0.4rem 0;
    background: linear-gradient(to right, #EEEFF8, #fff, #EEEFF8);
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
    border-radius: .2rem;
}

.tktopleft {
    width: 25%;
}

.tktopright {
    width: 75%;
    color: #0039A9;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.lefttouxiang {
    width: 100%;
    display: block;
    margin: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.txout {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50rem;
    overflow: hidden;
    position: relative;
    margin: auto;
    background: #fff;
}

.tkname {
    font-size: .55rem;
    font-weight: bold;
}

.tkinnerrow {
    padding: 0.4rem 0;
    width: 85%;
    border-bottom: 1px solid #0039A9;
    margin: auto;
    color: #0039A9
}

.day {
    background: #0039A9;
    color: #fff;
    padding: 0 0.1rem;
}

.tkdayrow {
    margin-bottom: 0.2rem;
}

.tkxueshurow {
    margin-bottom: 0.1rem;
}

.tkkhrow {
    margin-bottom: 0.1rem;
}

.tktitlerow {
    margin-bottom: 0.3rem;
}

.tktime {
    margin-bottom: 0.3rem;
}

.tkpos {
    margin-bottom: 0.3rem;
}

.tkopen {
    // text-align: right;
    font-size: .28rem;
    color: #fff;
    background-image: linear-gradient(to right, #1A429C, #173EB9);
    border-radius: 5px;
    padding: 0.05rem 0.1rem;
    display: inline-block;
}

.s1 {
    font-family: cursive;
    font-weight: bold;
    margin-left: 0.1rem;
    vertical-align: middle;
}

.s2 {
    font-family: cursive;
    font-weight: bold;
    vertical-align: middle;
    color: #c2c2c2;
}

.s3 {
    font-family: cursive;
    font-weight: bold;
    vertical-align: middle;
    color: #dddcdc;
}

.tkimg {
    width: .34rem;
    transform: translateY(0.025rem);
    margin-right: 0.1rem;
}

.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
    z-index: 99999;
    /* 新增拖动相关样式 */
    touch-action: none;
    /* 禁用浏览器默认触摸行为 */
    user-select: none;
    /* 防止拖动时选中文字 */
    -webkit-user-drag: element;
    /* 开启移动端拖动 */
    cursor: move;
    /* 鼠标指针提示可拖动 */
    transition: transform 0.1s ease;
    /* 拖动过渡更顺滑 */
}

.backbtn:active {
    opacity: 1;
    /* 拖动时提高透明度，增强反馈 */
    transform: translateY(-50%) scale(1.05);
    /* 拖动时轻微放大，提升体验 */
}

.backbtn img {
    width: 100%;
    pointer-events: none;
    /* 让拖动事件穿透到父元素 */
}
</style>